/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import MonthlyOrderBarChart from './MonthlyOrderBarChart';

const MonthlyOrderByCateg = ({ dir, data, categorisedBasedOn, dataMonthWise,
    monthsBetweenDates, title, viewReportButton, height }) => {

    const allCategories = {};

    data.forEach((item) => {
        if (item && !allCategories[item?.[categorisedBasedOn]]) {
            allCategories[item[categorisedBasedOn]] = item?.[categorisedBasedOn]
        }
    });

    const dataToPlot = []

    for (let i = 0; i < monthsBetweenDates.length; i += 1) {
        const [year, month] = monthsBetweenDates?.[i]?.split('-');
        const key = `${month}-${year}`
        const monthData = dataMonthWise[key];
        const dataItem = {
            title: key,
        };

        monthData?.reduce((acc, item) => {
            if (acc[item?.[categorisedBasedOn]]) {
                acc[item[categorisedBasedOn]] += Number(item.orderCount)
            } else {
                acc[item[categorisedBasedOn]] = Number(item.orderCount)
            };

            return acc
        }, dataItem);

        dataToPlot.push(dataItem)
    }

    console.log('dataToPlot', dataToPlot, allCategories)

    return (
        <Card className="pb-3 show-categ-daily-sales monthly-sub-order">
            <div className="card__title row ">
                <h5 className="bold-text col-md-4">{title}</h5>
                <div id='dvChartView'>
                {viewReportButton?.()}</div>
            </div>

            {dataToPlot?.length ?
                <MonthlyOrderBarChart
                    data={dataToPlot}
                    allCategories={Object.keys(allCategories)}
                    height={height}
                    showTitle={false}
                    dir={dir}
                    monthsBetweenDates={monthsBetweenDates}
                />
                : 'No data to display'}

        </Card>
    )
}

MonthlyOrderByCateg.propTypes = {
    dir: PropTypes.string.isRequired,
    data: PropTypes.array.isRequired,
    dataMonthWise: PropTypes.object.isRequired,
    monthsBetweenDates: PropTypes.arrayOf({}).isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
    categorisedBasedOn: PropTypes.string,
    height: PropTypes.number.isRequired,
};

MonthlyOrderByCateg.defaultProps = {
    title: 'Month Comparison By Category',
    categorisedBasedOn: 'productCategory'
}

export default MonthlyOrderByCateg;
